import React, { useRef } from 'react'
import { RiMailLine } from '@remixicon/react'
import SlideUp from '../../../utlits/animations/slideUp'
import emailjs from 'emailjs-com';

const ContactForm = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_yqmp2p7', 'template_z7p45zf', form.current, '-y4jBdHr_WpaxBkSy')
            .then((result) => {
                console.log(result.text);
                alert("Mensaje enviado correctamente");
            }, (error) => {
                console.log(error.text);
                alert("Hubo un error al enviar el mensaje");
            });

        e.target.reset();
    };

    return (
        <div className="col-lg-8">
            <SlideUp>
                <div className="contact-form contact-form-area">
                    <form ref={form} onSubmit={sendEmail} className="contactForm" name="contactForm">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label for="name">Nombre</label>
                                    <input type="text" id="name" name="from_name" className="form-control" placeholder="Steve Milner" required="" data-error="Please enter your Name" />
                                    <label for="name" className="for-icon"><i className="far fa-user"></i></label>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label for="email">Correo electrónico</label>
                                    <input type="email" id="email" name="from_email" className="form-control" placeholder="hello@websitename.com" required="" data-error="Please enter your Email" />
                                    <label for="email" className="for-icon"><i className="far fa-envelope"></i></label>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label for="message">¡Cuéntame!</label>
                                    <textarea name="message" id="message" className="form-control" rows="4" placeholder="Write Your message" required="" data-error="Please Write your Message"></textarea>
                                    <div className="help-block with-errors"></div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group mb-0">
                                    <button type="submit" className="theme-btn">
                                        Enviar mensaje<i><RiMailLine size={15} /></i>
                                    </button>
                                    <div id="msgSubmit" className="hidden"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </SlideUp>
        </div>
    )
}

export default ContactForm